// extracted by mini-css-extract-plugin
module.exports = {"box":"ExaloanGrades_box__2wBha","content":"ExaloanGrades_content__1pZ7i"};